<template>


<div class="container">
  <loading :active.sync="isLoading" 
        color="#51c569"
        loader="bars"
        :is-full-page="fullPage"
        width:2
        height:2
        ></loading>
<div class="row row-cols-1 row-cols-md-2 row-cols-xl-4">
       <div class="col">
		 <div class="card radius-10 border-start border-0 border-3 border-info" @click="show_farmer()">
			<div class="card-body">
				<div class="d-flex align-items-center">
					<div>
						<p class="mb-0 text-secondary">Total Farmers</p>
						<h4 class="my-1 text-info">{{form.totalFarmers}}</h4>
						<p class="mb-0 font-13"></p>
					</div>
					<div class="widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto"><i class="fa fa-user"></i>
					</div>
				</div>
			</div>
		 </div>
	   </div>
	   <div class="col">
		<div class="card radius-10 border-start border-0 border-3 border-danger" @click="show_order()">
		   <div class="card-body">
			   <div class="d-flex align-items-center">
				   <div>
					   <p class="mb-0 text-secondary">Total Collection</p>
					   <h4 class="my-1 text-danger">{{form.totalOrders}}</h4>
					   <p class="mb-0 font-13"></p>
				   </div>
				   <div class="widgets-icons-2 rounded-circle bg-gradient-bloody text-white ms-auto"><i class="fa fa-trash"></i>
				   </div>
			   </div>
		   </div>
		</div>
	  </div>
	  <div class="col">
		<div class="card radius-10 border-start border-0 border-3 border-success">
		   <div class="card-body">
			   <div class="d-flex align-items-center">
				   <div>
					   <p class="mb-0 text-secondary">Total Bill Amount</p>
					   <h4 class="my-1 text-success">₹ {{form.totalBillAmount}}</h4>
					   <p class="mb-0 font-13"></p>
				   </div>
				   <div class="widgets-icons-2 rounded-circle bg-gradient-ohhappiness text-white ms-auto"><i class="fa fa-strikethrough"></i>
				   </div>
			   </div>
		   </div>
		</div>
	  </div>
	  <div class="col">
		<div class="card radius-10 border-start border-0 border-3 border-danger">
		   <div class="card-body">
			   <div class="d-flex align-items-center">
				   <div>
					   <p class="mb-0 text-secondary">Pending Bill Amount</p>
					   <h4 class="my-1 text-danger" >₹ {{form.pendingBillAmount}}</h4>
					   <p class="mb-0 font-13"></p>
				   </div>
				   <div class="widgets-icons-2 rounded-circle bg-gradient-bloody text-white ms-auto"><i class="fa fa-inr"></i>
				   </div>
			   </div>
		   </div>
		</div>
	  </div> 
    <div class="col">
		<div class="card radius-10 border-start border-0 border-3 border-warning">
		   <div class="card-body">
			   <div class="d-flex align-items-center">
				   <div>
					   <p class="mb-0 text-secondary">Paid Bill Amount</p>
					   <h4 class="my-1 text-warning">₹ {{form.paidBillAmount}}</h4>
					   <p class="mb-0 font-13"></p>
				   </div>
				   <div class="widgets-icons-2 rounded-circle bg-gradient-blooker text-white ms-auto"><i class="fa fa-inr"></i>
				   </div>
			   </div>
		   </div>
		</div>
	  </div> 
	</div>
</div>
</template>
<script>
  import apis from "@/apis";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      society_id:"",
      form:{
        totalFarmers:"",
        totalOrders:"",
        totalBillAmount:"",
        pendingBillAmount:"",
        paidBillAmount:""
      }
    };
  },
  methods: {
    show_order()
    {
      this.$router.push("/register");
    },
    show_farmer()
    {
      this.$router.push("/members");
    },
    load_dashboard()
    {
      this.isLoading = true;
      var data = { societyid: parseInt(this.society_id)};
      var promise = apis.getdashboarddata(data);
      promise
        .then((response) => {
          this.isLoading = false;
          if (response.data) {
            this.form = response.data;
          } else {
            alert("data not found");
          }
        })
        .catch((error) => {
          alert(error);
        });
    }
  },
  components: {Loading},
  watch: {},
  created() {},
  mounted() {
    // this.society_id = this.$session.get("id");
    this.society_id = localStorage.getItem('id');
    //this.society_id = 1;
    this.load_dashboard();
  },
};
</script>

<style scoped>
body{
margin-top:20px;
background-color: #f7f7ff;
}
.radius-10 {
    border-radius: 10px !important;
}

.border-info {
    border-left: 5px solid  #0dcaf0 !important;
}
.border-danger {
    border-left: 5px solid  #fd3550 !important;
}
.border-success {
    border-left: 5px solid  #15ca20 !important;
}
.border-warning {
    border-left: 5px solid  #ffc107 !important;
}
.border-new {
    border-left: 5px solid  #fc04be !important;
}


.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 0px solid rgba(0, 0, 0, 0);
    border-radius: .25rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 2px 6px 0 rgb(218 218 253 / 65%), 0 2px 6px 0 rgb(206 206 238 / 54%);
}
.bg-gradient-scooter {
    background: #17ead9;
    background: -webkit-linear-gradient( 
45deg
 , #17ead9, #6078ea)!important;
    background: linear-gradient( 
45deg
 , #17ead9, #6078ea)!important;
}
.widgets-icons-2 {
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ededed;
    font-size: 27px;
    border-radius: 10px;
}
.rounded-circle {
    border-radius: 50%!important;
}
.text-white {
    color: #fff!important;
}
.ms-auto {
    margin-left: auto!important;
}
.bg-gradient-bloody {
    background: #f54ea2;
    background: -webkit-linear-gradient( 
45deg
 , #f54ea2, #ff7676)!important;
    background: linear-gradient( 
45deg
 , #f54ea2, #ff7676)!important;
}

.bg-gradient-ohhappiness {
    background: #00b09b;
    background: -webkit-linear-gradient( 
45deg
 , #00b09b, #96c93d)!important;
    background: linear-gradient( 
45deg
 , #00b09b, #96c93d)!important;
}

.bg-gradient-blooker {
    background: #ffdf40;
    background: -webkit-linear-gradient( 
45deg
 , #ffdf40, #ff8359)!important;
    background: linear-gradient( 
45deg
 , #ffdf40, #ff8359)!important;
}   
</style>